import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SubmissionSummaryService } from '../../data-access/services/submission-summary.service';

@Component({
  selector: 'app-comments-summary',
  templateUrl: './comments-summary.component.html',
  styleUrls: ['./comments-summary.component.scss'],
  standalone: false,
})
export class CommentsSummaryComponent implements OnInit {
  @Input() currentYear!: number;
  @Input() prfNumber!: string;
  @Input() groupCode!: string;
  comments = '';
  commentsLoaded = false;
  constructor(private readonly submissionSummaryService: SubmissionSummaryService, private readonly router: Router) {} 
  ngOnInit(): void {
    this.getComments();
  }
  private getComments() {
    this.submissionSummaryService
      .getComments(this.currentYear, this.prfNumber, this.groupCode)
      .subscribe({
        next: (comment) => {
          if (comment !== null) {
            this.comments = comment;
            this.commentsLoaded = true;
          }
        },
        error: (error) => {
          this.commentsLoaded = false;
          this.router.navigate(['/apifailure']);
        },
      });
  }
}
